export const isDateInFuture = (dateString: string) => {
  return new Date(dateString) > new Date();
};

type CountdownTarget = {
  isUpdateDisabled: boolean;
  countdownTarget: string;
};

export const getCountdownTarget = (dateStrings: (string | null)[]): CountdownTarget => {
  const validDates = dateStrings.filter((d): d is string => d !== null && isDateInFuture(d));
  const isUpdateDisabled = validDates.length > 0;
  const countdownTarget = isUpdateDisabled ? validDates.reduce((max, curr) => (curr > max ? curr : max)) : '';

  return {isUpdateDisabled, countdownTarget};
};